export default "__VITE_ASSET__BuUL$iFx__"